import { render, staticRenderFns } from "./FilesActivityTable.vue?vue&type=template&id=ada4f746&scoped=true"
import script from "./FilesActivityTable.vue?vue&type=script&lang=js"
export * from "./FilesActivityTable.vue?vue&type=script&lang=js"
import style0 from "./FilesActivityTable.vue?vue&type=style&index=0&id=ada4f746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada4f746",
  null
  
)

export default component.exports